module.exports = __webpack_public_path__ + "static/media/realtalk_sd_shoc17b148853e13ab7ccca8f719be19eb7.webp";